import enGB from './en-gb';
import frFR from './fr-fr';

const translations = {
  'en-gb': enGB,
  'fr-fr': frFR
};

export default translations;
